import React from 'react'
import profile from '../assets/profile.jpg'
import { Globe, MapPin, Clock, BriefcaseBusiness, Mailbox, Download, GraduationCap } from 'lucide-react'
import { HoverBorderGradient } from './components/ui/hover-border-gradient.tsx'

function Profile() {
    return (
        <div className="p-3 relative w-full  bg-opacity-10 rounded-lg">
            <div className='flex items-center gap-4 relative'>
                <img src={profile} alt="" className='rounded-lg w-20 aspect-square object-cover' />
                <div className='flex-1'>
                    <div className='flex gap-2 items-center'>
                        <div className="pulsating-circle pulsate-green"></div>
                        <p className='text-xs'>Available to Work</p>
                    </div>
                    <h1 className='text-lg font-semibold text-blue-400'>Alexis Eleserio</h1>
                    <p className='text-sm'>I'm a <span className='text-blue-300'>Full Stack Developer</span></p>
                </div>
            </div>
            <div className="flex gap-2 mt-3 flex-wrap">
                <Badge icon={<Globe className="w-4 h-4" />} text="English & Filipino" />
                <Badge icon={<MapPin className="w-4 h-4" />} text="Cavite, Philippines" />
                <Badge icon={<Clock className="w-4 h-4" />} text="UTC+08:00" />
                <Badge icon={<GraduationCap className="w-4 h-4" />} text="4th Year College" />
                <Badge icon={<BriefcaseBusiness className="w-4 h-4" />} text="Freelance" />
            </div>
            <div className="flex gap-2 mt-3">
                <HoverBorderGradient
                    containerClassName="rounded-2xl border-none flex-1"
                    as="a"
                    target="_blank"
                    href="https://www.linkedin.com/in/alexis-eleserio-55300b243/"
                    className="flex gap-2 items-center justify-center p-2 bg-blue-600 hover:bg-blue-500 duration-300 w-full"
                >
                    <Mailbox className="w-5 h-5" />
                    <span>Hire Me</span>
                </HoverBorderGradient>
                <a href={`/CV.pdf`} download="CV_Alexis_Eleserio.pdf" className="bg-gray-800 hover:bg-gray-700 duration-300 rounded-2xl flex gap-2 items-center justify-center flex-1">
                    <Download className="w-4 h-4" />
                    <p className='text-xs md:text-sm lg:text-md xl:text-md'>Download CV</p>
                </a>
            </div>
        </div>
    )
}

const Badge = ({icon, text}) => {
    return (
        <div className='rounded-xl bg-gray-700 flex items-center gap-1.5 p-2'>
            {icon}
            <p className='text-[0.5em] lg:text-[0.7em] text-nowrap'>{text}</p>
        </div>
    );
}

export default Profile